import React, { memo } from 'react'
import Form, { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Input from '@active/react-ui/Input'
import IntlPhoneInput from '@active/react-ui/IntlPhoneInput'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'
import Button from '@active/react-ui/Button'
import LinkButton from '@active/react-ui/LinkButton'
import Checkbox from '@active/react-ui/Checkbox'
import CheckboxGroup from '@active/react-ui/CheckboxGroup'
import Responsive from '@active/react-utils/components/Responsive'
import Identity from '@active/react-utils/components/Identity'
import { withI18n } from '@active/react-utils/i18n'
import noop from 'lodash/fp/noop'
import {
  bool, func, string, number, oneOfType,
} from 'prop-types'
import I18nMessage from '../../../I18nMessage'
import './VerifyCodeByNewPhone.scss'

function VerifyCodeByNewPhone({
  onSendCode,
  onChangeTrustDevice,
  countDownNumber,
  showSentCodeWording,
  showMethodChangeLink,
  showTrustDevice,
  onChangeMethod,
  proxyForm,
  proxyPhoneForm,
  phoneNumber,
  isTrustDevice,
  i18n,
  sendCodeButtonText,
  locale = 'en_US',
}) {
  const buttonText = sendCodeButtonText || 'passport.common.btn.send'
  return (
    <Identity>
      <div className="verify-code-by-new-phone-form">
        <Grid fluid rowGap={0} colGap={0}>
          <GridItem span={12} spanSm={8}>
            <Form initialValues={{
              phoneNumber,
            }}
            >
              <FormGroup name="phoneNumber" className="relative" required withoutLayout>
                <FormLabel>
                  <I18nMessage id="passport.phoneAuthentication.modal.input.label.mobilePhoneNumber" />
                </FormLabel>
                <FormField
                  defaultLocale={locale}
                  placeholder={i18n('passport.verification.modal.input.phone.placeholder')}
                  as={IntlPhoneInput}
                  requiredError={i18n('passport.verification.modal.input.phone.required.error')}
                />
                <Responsive eqAbove="sm">
                  <Button type="primary" className="sent-btn" onClick={onSendCode} disabled={!!countDownNumber}>{countDownNumber ? `${countDownNumber}s` : <I18nMessage id={buttonText} />}</Button>
                </Responsive>
              </FormGroup>
              <FormConsumer>
                {
                  ({ form }) => {
                    proxyPhoneForm(form)
                  }
                }
              </FormConsumer>
            </Form>
          </GridItem>
          {showSentCodeWording && (
            <GridItem className="sent-code-wording" rowGap={0} span={12} spanSm={8}>
              <i className="ic-check-r" />
              <I18nMessage id="passport.security.setting.sent.code.tips" />
            </GridItem>
          )}
          {
            showMethodChangeLink && (
              <Responsive eqAbove="sm">
                <GridItem span={12} className="mg-t-4">
                  <LinkButton onClick={() => onChangeMethod('EMAIL')}>
                    <I18nMessage id="passport.phoneAuthentication.modal.change.method.link" />
                  </LinkButton>
                </GridItem>
              </Responsive>
            )
          }
          <Responsive eqAbove="sm" not>
            <GridItem span={12} className={showMethodChangeLink ? 'flex-space-between links' : 'txt-right links'}>
              {
                showMethodChangeLink && (
                  <LinkButton onClick={() => onChangeMethod('EMAIL')}>
                    <I18nMessage id="passport.phoneAuthentication.modal.change.method.link" />
                  </LinkButton>
                )
              }
              <Button type="primary" onClick={onSendCode} disabled={!!countDownNumber}>
                {countDownNumber ? `${countDownNumber}s` : <I18nMessage id={buttonText} />}
              </Button>
            </GridItem>
          </Responsive>
          <GridItem span={12} spanSm={8} className="mg-t-6">
            <Form initialValues={{
              isTrustDevice: [`${isTrustDevice}`],
            }}
            >
              <FormGroup name="code" required withoutLayout>
                <FormLabel>
                  <I18nMessage id="passport.verification.modal.input.placeholder" />
                </FormLabel>
                <FormField
                  placeholder={i18n('passport.verification.modal.input.code.placeholder')}
                  as={Input}
                  requiredError={i18n('passport.verification.modal.input.code.required.error')}
                />
              </FormGroup>
              {
                showTrustDevice && (
                <GridItem span={12} className="mg-t-6">
                  <FormGroup name="isTrustDevice" withoutLayout>
                    <FormLabel />
                    <FormField as={CheckboxGroup}>
                      <Checkbox value="true" onChange={onChangeTrustDevice}>
                        <I18nMessage id="passport.trust.device.label.authorized" />
                      </Checkbox>
                    </FormField>
                  </FormGroup>
                </GridItem>
                )
              }
              <FormConsumer>
                {
                  ({
                    form,
                  }) => {
                    proxyForm(form)
                  }
                }
              </FormConsumer>
            </Form>
          </GridItem>
        </Grid>
      </div>
    </Identity>
  )
}

VerifyCodeByNewPhone.propTypes = {
  phoneNumber: string,
  isTrustDevice: bool,
  proxyForm: func.isRequired,
  proxyPhoneForm: func,
  countDownNumber: oneOfType([string, number]),
  onSendCode: func.isRequired,
  onChangeTrustDevice: func,
  showMethodChangeLink: bool,
  showTrustDevice: bool,
  onChangeMethod: func,
  showSentCodeWording: bool,
  i18n: func.isRequired,
  sendCodeButtonText: string,
  locale: string,
}
VerifyCodeByNewPhone.defaultProps = {
  phoneNumber: null,
  isTrustDevice: false,
  proxyPhoneForm: noop,
  onChangeTrustDevice: noop,
  countDownNumber: 0,
  showMethodChangeLink: false,
  showTrustDevice: true,
  onChangeMethod: noop,
  showSentCodeWording: false,
  sendCodeButtonText: undefined,
  locale: 'en_US',
}
export default memo(withI18n(VerifyCodeByNewPhone))
